var NATIVE_SYMBOL = require('../internals/native-symbol');

module.exports = NATIVE_SYMBOL
  // eslint-disable-next-line no-undef
  && !Symbol.sham
  // eslint-disable-next-line no-undef
  && typeof Symbol.iterator == 'symbol';



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/internals/use-symbol-as-uid.js
// module id = 239
// module chunks = 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35